export const buildInviteLinkFromToken = (token) => 'https://valovate.com/join?token=' + encodeURIComponent(token);
export const buildDesktopInviteLink = (token) => 'valovate://join?token=' + encodeURIComponent(token);
